var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHtml(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 100,
    viewBox: "0 0 101 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "HTML5_logo_and_wordmark 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.6719 0H26.1641V4.45312H30.3047V0H34.7969V13.4766H30.3047V8.98438H26.2031V13.4766H21.6719M40.7344 4.49219H36.7695V0H49.2109V4.49219H45.2266V13.4766H40.7344M51.1836 0H55.8906L58.7812 4.74609L61.6719 0H66.3789V13.4766H61.8867V6.79688L58.7422 11.6406L55.5977 6.79688V13.4766H51.1836M68.6055 0H73.0977V9.02344H79.4648V13.4766H68.6055",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M21.5156 91.9922L15.0703 19.6484H85.9297L79.4844 91.9531L50.4414 100",
    fill: "#E44D26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M50.5 93.8477V25.5859H79.4648L73.9375 87.3047",
    fill: "#F16529"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M28.2344 34.4336H50.5V43.3008H37.9609L38.7812 52.3828H50.5V61.2305H30.6562M31.0469 65.6836H39.9531L40.5781 72.7734L50.5 75.4297V84.6875L32.2969 79.6094",
    fill: "#EBEBEB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M72.6875 34.4336H50.4609V43.3008H71.8672M71.0664 52.3828H50.4609V61.25H61.3984L60.3633 72.7734L50.4609 75.4297V84.6484L68.625 79.6094",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHtml);
export default __webpack_public_path__ + "static/media/html.b3218f6fc8a8923c436e8a051f59756c.svg";
export { ForwardRef as ReactComponent };